import { createContext } from "react";

const XthemeContext = createContext();

export default XthemeContext;
